/** Release 3 REV-2 — one line per board activity item (audit action → wording). */
import type { BoardActivityItem } from '@/lib/api/queries';

const str = (v: unknown): string | null => (typeof v === 'string' && v.length ? v : null);

export function activityLine(i: BoardActivityItem): string {
  const who = i.actor?.display_name ?? i.actor?.guest_name ?? (i.actor?.kind === 'guest' ? 'A guest' : 'Lumen');
  const title = i.asset_title ?? 'an asset';
  const m = (i.metadata ?? {}) as Record<string, unknown>;
  if (i.kind === 'comment') return `${who} commented on ${title}`;
  switch (i.action) {
    case 'asset.upload_complete': return `${who} uploaded ${title}`;
    case 'asset.upload_start': return `${who} started uploading ${title}`;
    case 'asset.create': return `${who} added ${title}`;
    case 'version.create': return `${who} uploaded a new version of ${title}`;
    case 'asset.approval_set': return `${who} set ${title} to ${str(m.to) ?? 'a new status'}`;
    case 'asset.boards_set': return `${who} moved ${title}`;
    case 'board.assets_add': return `${who} added ${typeof m.added === 'number' ? `${m.added} asset${m.added === 1 ? '' : 's'}` : 'assets'} to the board`;
    case 'board.asset_remove': return `${who} removed ${title} from the board`;
    case 'board.create': return `${who} created the board`;
    case 'board.update': return `${who} changed the board settings`;
    case 'board.move': return `${who} moved the board`;
    case 'board.archive': return `${who} archived the board`;
    case 'board.unarchive': return `${who} restored the board`;
    case 'board.cover_set': return `${who} changed the board cover`;
    case 'share_link.access': return `A share link was opened${str(m.visitor_name) ? ` by ${m.visitor_name}` : ''}`;
    case 'share_link.download': return `Files were downloaded through a share link${str(m.visitor_name) ? ` by ${m.visitor_name}` : ''}`;
    case 'asset.download': return `${title} was downloaded through a share link`;
    default: return `${who}: ${i.action.replace(/[._]/g, ' ')}`;
  }
}
